export default __webpack_public_path__ + "static/media/excellent.c18bde62.svg";